/* CE Search — Cmd+K overlay with Shopify Predictive Search API.
   Progressive enhancement: triggers are <a href="/search"> without JS. */

(function () {
  'use strict';

  var DIALOG_ID = 'ce-search-dialog';
  var RECENT_KEY = 'ce-search-recent';
  var RECENT_MAX = 5;
  var DEBOUNCE_MS = 180;
  var SEARCH_URL = '/search/suggest.json';
  var RESOURCE_TYPES = 'product,collection,page,article,query';
  var RESOURCE_LIMIT = 6;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  function isMac() {
    return /mac|iphone|ipad|ipod/i.test(navigator.platform || navigator.userAgent);
  }

  function setKbdLabels() {
    var label = isMac() ? '⌘K' : 'Ctrl K';
    $$('[data-ce-search-kbd]').forEach(function (el) { el.textContent = label; });
  }

  function loadRecent() {
    try {
      var raw = localStorage.getItem(RECENT_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) { return []; }
  }

  function saveRecent(query) {
    if (!query || query.length < 2) return;
    var list = loadRecent().filter(function (q) { return q !== query; });
    list.unshift(query);
    list = list.slice(0, RECENT_MAX);
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list)); } catch (e) {}
  }

  function clearRecent() {
    try { localStorage.removeItem(RECENT_KEY); } catch (e) {}
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function formatMoney(cents) {
    if (cents == null) return '';
    try {
      return (cents / 100).toLocaleString('de-DE', {
        style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR',
        minimumFractionDigits: 2, maximumFractionDigits: 2
      });
    } catch (e) {
      return (cents / 100).toFixed(2) + ' €';
    }
  }

  function init() {
    var dialog = document.getElementById(DIALOG_ID);
    if (!dialog) return;

    var input = $('[data-ce-search-input]', dialog);
    var body = $('[data-ce-search-body]', dialog);
    var closeBtn = $('[data-ce-search-close]', dialog);
    var recentWrap = $('[data-ce-search-recent]', dialog);
    var recentList = $('[data-ce-search-recent-list]', dialog);
    var clearRecentBtn = $('[data-ce-search-clear-recent]', dialog);
    var bestsellersWrap = $('[data-ce-search-bestsellers]', dialog);
    var categoriesWrap = $('[data-ce-search-categories]', dialog);
    var resultsWrap = $('[data-ce-search-results]', dialog);
    var loading = $('[data-ce-search-loading]', dialog);
    var emptyWrap = $('[data-ce-search-empty]', dialog);
    var emptyQuery = $('[data-ce-search-empty-query]', dialog);
    var emptyLink = $('[data-ce-search-empty-link]', dialog);
    var viewAll = $('[data-ce-search-view-all]', dialog);
    var form = $('.ce-search__form', dialog);

    var debounceTimer = null;
    var activeIndex = -1;
    var currentQuery = '';
    var lastAbort = null;

    setKbdLabels();
    renderRecent();

    function open() {
      if (dialog.open) return;
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      document.documentElement.classList.add('ce-search-open');
      renderRecent();
      setTimeout(function () { input && input.focus(); }, 20);
    }

    function close() {
      if (!dialog.open && typeof dialog.close === 'function') return;
      if (typeof dialog.close === 'function') { dialog.close(); }
      else { dialog.removeAttribute('open'); }
      document.documentElement.classList.remove('ce-search-open');
      resetBody();
    }

    function resetBody() {
      input.value = '';
      currentQuery = '';
      activeIndex = -1;
      resultsWrap.hidden = true;
      resultsWrap.innerHTML = '';
      loading.hidden = true;
      emptyWrap.hidden = true;
      viewAll.hidden = true;
      showEmptyState(true);
    }

    function showEmptyState(show) {
      if (bestsellersWrap) bestsellersWrap.hidden = !show;
      if (categoriesWrap) categoriesWrap.hidden = !show;
      renderRecent();
      if (recentWrap) recentWrap.hidden = !show || loadRecent().length === 0;
    }

    function renderRecent() {
      if (!recentList) return;
      var list = loadRecent();
      if (list.length === 0) {
        if (recentWrap) recentWrap.hidden = true;
        return;
      }
      recentList.innerHTML = list.map(function (q) {
        var href = '/search?q=' + encodeURIComponent(q);
        return '<li><a href="' + escapeHtml(href) + '" class="ce-search__recent-item" data-ce-search-recent-query="' + escapeHtml(q) + '">'
          + '<i class="ri-history-line" aria-hidden="true"></i>'
          + '<span>' + escapeHtml(q) + '</span>'
          + '</a></li>';
      }).join('');
      if (recentWrap) recentWrap.hidden = false;
    }

    function onInput() {
      var q = input.value.trim();
      currentQuery = q;
      activeIndex = -1;
      clearTimeout(debounceTimer);
      if (q.length === 0) {
        resultsWrap.hidden = true;
        resultsWrap.innerHTML = '';
        loading.hidden = true;
        emptyWrap.hidden = true;
        viewAll.hidden = true;
        showEmptyState(true);
        return;
      }
      if (q.length < 2) return;
      showEmptyState(false);
      loading.hidden = false;
      debounceTimer = setTimeout(function () { doSearch(q); }, DEBOUNCE_MS);
    }

    function doSearch(q) {
      if (lastAbort) { try { lastAbort.abort(); } catch (e) {} }
      var controller = ('AbortController' in window) ? new AbortController() : null;
      lastAbort = controller;

      var params = new URLSearchParams({
        q: q,
        'resources[type]': RESOURCE_TYPES,
        'resources[limit]': String(RESOURCE_LIMIT),
        'resources[limit_scope]': 'each',
        /* Widen match scope to product_type, variants.title and tag — but
           NOT body. Description matches caused noisy results where the query
           word only appeared in a product's long description text. */
        'resources[options][fields]': 'title,product_type,variants.title,vendor,tag',
        'resources[options][unavailable_products]': 'last'
      });
      var url = SEARCH_URL + '?' + params.toString();

      fetch(url, { signal: controller ? controller.signal : undefined, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (q !== currentQuery) return;
          renderResults(data.resources && data.resources.results ? data.resources.results : {}, q);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          loading.hidden = true;
        });
    }

    function renderResults(r, q) {
      loading.hidden = true;
      var parts = [];
      var total = 0;

      if (r.products && r.products.length) {
        total += r.products.length;
        parts.push(sectionHtml('Produkte', r.products.map(productRowHtml).join('')));
      }
      if (r.collections && r.collections.length) {
        total += r.collections.length;
        parts.push(sectionHtml('Kategorien', r.collections.map(collectionRowHtml).join('')));
      }
      if (r.pages && r.pages.length) {
        total += r.pages.length;
        parts.push(sectionHtml('Seiten', r.pages.map(pageRowHtml).join('')));
      }
      if (r.articles && r.articles.length) {
        total += r.articles.length;
        parts.push(sectionHtml('Artikel', r.articles.map(pageRowHtml).join('')));
      }
      if (r.queries && r.queries.length) {
        parts.push(sectionHtml('Vorschläge', r.queries.map(queryRowHtml).join('')));
      }

      if (total === 0 && (!r.queries || r.queries.length === 0)) {
        resultsWrap.hidden = true;
        resultsWrap.innerHTML = '';
        emptyQuery.textContent = q;
        emptyLink.setAttribute('href', '/search?q=' + encodeURIComponent(q));
        emptyWrap.hidden = false;
        viewAll.hidden = true;
        return;
      }

      emptyWrap.hidden = true;
      resultsWrap.innerHTML = parts.join('');
      resultsWrap.hidden = false;
      viewAll.hidden = false;
      viewAll.setAttribute('href', '/search?q=' + encodeURIComponent(q));
      activeIndex = -1;
    }

    function sectionHtml(title, inner) {
      return '<div class="ce-search__section">'
        + '<div class="ce-search__section-head"><span class="ce-search__section-title">' + escapeHtml(title) + '</span></div>'
        + '<ul class="ce-search__results-list">' + inner + '</ul>'
        + '</div>';
    }

    function productRowHtml(p) {
      var img = p.featured_image && p.featured_image.url
        ? '<img src="' + escapeHtml(p.featured_image.url) + '" alt="" loading="lazy" width="40" height="40">'
        : '<i class="ri-image-line" aria-hidden="true"></i>';
      var priceStr = '';
      if (p.price != null) priceStr = formatMoney(parseFloat(p.price) * 100);
      else if (p.price_min != null) priceStr = formatMoney(parseFloat(p.price_min) * 100);
      var vendor = p.vendor ? '<span class="ce-search__result-meta">' + escapeHtml(p.vendor) + '</span>' : '';
      return '<li>'
        + '<a href="' + escapeHtml(p.url) + '" class="ce-search__result" data-ce-search-result data-type="product">'
        + '<span class="ce-search__result-media">' + img + '</span>'
        + '<span class="ce-search__result-body">'
        + '<span class="ce-search__result-title">' + escapeHtml(p.title) + '</span>'
        + vendor
        + '</span>'
        + '<span class="ce-search__result-price">' + escapeHtml(priceStr) + '</span>'
        + '</a></li>';
    }

    function collectionRowHtml(c) {
      return '<li>'
        + '<a href="' + escapeHtml(c.url) + '" class="ce-search__result ce-search__result--compact" data-ce-search-result data-type="collection">'
        + '<span class="ce-search__result-media ce-search__result-media--icon"><i class="ri-folder-3-line" aria-hidden="true"></i></span>'
        + '<span class="ce-search__result-body"><span class="ce-search__result-title">' + escapeHtml(c.title) + '</span></span>'
        + '</a></li>';
    }

    function pageRowHtml(p) {
      return '<li>'
        + '<a href="' + escapeHtml(p.url) + '" class="ce-search__result ce-search__result--compact" data-ce-search-result data-type="page">'
        + '<span class="ce-search__result-media ce-search__result-media--icon"><i class="ri-file-text-line" aria-hidden="true"></i></span>'
        + '<span class="ce-search__result-body"><span class="ce-search__result-title">' + escapeHtml(p.title) + '</span></span>'
        + '</a></li>';
    }

    function queryRowHtml(q) {
      var term = q.text || q.styled_text || '';
      var href = q.url || ('/search?q=' + encodeURIComponent(term));
      return '<li>'
        + '<a href="' + escapeHtml(href) + '" class="ce-search__result ce-search__result--compact" data-ce-search-result data-type="query">'
        + '<span class="ce-search__result-media ce-search__result-media--icon"><i class="ri-search-line" aria-hidden="true"></i></span>'
        + '<span class="ce-search__result-body"><span class="ce-search__result-title">' + escapeHtml(term) + '</span></span>'
        + '</a></li>';
    }

    /* Keyboard navigation across all visible result links */
    function navigableItems() {
      return $$('[data-ce-search-result], [data-ce-search-recent-query], .ce-search__chip, [data-ce-search-bestsellers] .ce-search__result', body)
        .filter(function (el) { return el.offsetParent !== null; });
    }

    function setActive(idx) {
      var items = navigableItems();
      if (items.length === 0) { activeIndex = -1; return; }
      activeIndex = ((idx % items.length) + items.length) % items.length;
      items.forEach(function (el, i) {
        if (i === activeIndex) {
          el.classList.add('is-active');
          el.scrollIntoView({ block: 'nearest' });
        } else {
          el.classList.remove('is-active');
        }
      });
    }

    function onKeydown(e) {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        setActive(activeIndex + 1);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        setActive(activeIndex - 1);
      } else if (e.key === 'Enter') {
        var items = navigableItems();
        if (activeIndex >= 0 && items[activeIndex]) {
          e.preventDefault();
          var href = items[activeIndex].getAttribute('href');
          if (href) {
            saveRecent(currentQuery);
            window.location.href = href;
          }
        } else if (currentQuery.length >= 2) {
          e.preventDefault();
          saveRecent(currentQuery);
          form.submit();
        }
      } else if (e.key === 'Escape') {
        close();
      }
    }

    /* Global open shortcuts */
    document.addEventListener('keydown', function (e) {
      var meta = e.metaKey || e.ctrlKey;
      if (meta && (e.key === 'k' || e.key === 'K')) {
        e.preventDefault();
        if (dialog.open) close(); else open();
        return;
      }
      if (e.key === '/' && !dialog.open) {
        var ae = document.activeElement;
        var isTyping = ae && (ae.tagName === 'INPUT' || ae.tagName === 'TEXTAREA' || ae.isContentEditable);
        if (isTyping) return;
        e.preventDefault();
        open();
      }
    });

    /* Trigger buttons */
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-ce-search-open]');
      if (trigger) {
        e.preventDefault();
        open();
        return;
      }
      var resultLink = e.target.closest('[data-ce-search-result], [data-ce-search-recent-query]');
      if (resultLink && dialog.open) {
        saveRecent(currentQuery || resultLink.getAttribute('data-ce-search-recent-query') || '');
      }
    });

    /* Backdrop click closes */
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) close();
    });

    dialog.addEventListener('cancel', function (e) {
      e.preventDefault();
      close();
    });

    closeBtn.addEventListener('click', close);
    input.addEventListener('input', onInput);
    input.addEventListener('keydown', onKeydown);

    if (clearRecentBtn) {
      clearRecentBtn.addEventListener('click', function () {
        clearRecent();
        renderRecent();
      });
    }

    /* Form submit = navigate to /search (fallback path) */
    form.addEventListener('submit', function () {
      saveRecent(input.value.trim());
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
